import React from 'react';
import { Navigate } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import RoutesApp from '../../routes';

//Estilos
import broken_glass from '../../assets/imgs/broken-glass.png';
import './404.css';

function Error404() {
    const { token } = useGlobalContext();

    if (!token) {
        return <Navigate to={RoutesApp.Login} />;
    }

    return (
        <div className="page_404-container">
            <h1>Error 404 pagina no encontrada</h1>
            <img src={broken_glass} alt="Pagina no encontrada" />
        </div>
    );
}

export default Error404;
